var map = {
	"./abathur.webp": 7632,
	"./alarak.webp": 6553,
	"./artanis.webp": 7651,
	"./dehaka.webp": 2971,
	"./fenix.webp": 8837,
	"./hanhorner.webp": 4140,
	"./karax.webp": 5430,
	"./kerrigan.webp": 5756,
	"./mengsk.webp": 7768,
	"./nova.webp": 2997,
	"./raynor.webp": 1080,
	"./stetmann.webp": 6803,
	"./stukov.webp": 5181,
	"./swann.webp": 7904,
	"./tychus.webp": 3455,
	"./vorazun.webp": 2086,
	"./zagara.webp": 3415,
	"./zeratul.webp": 1588
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2288;